import { Component, Input, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { ProductInfo } from '@app-model/product';
import { ProductService } from '@app-services/product.service';
import { UserInfo } from '@app-store/session/session.store';
import { SessionQuery } from '@app-store/session/session.query';

@Component({
	selector: 'app-layout-restrict-area-footer',
	templateUrl: './layout-restrict-area-footer.component.html',
	styleUrls: ['./layout-restrict-area-footer.component.scss']
})
export class LayoutRestrictAreaFooterComponent implements OnInit {
	productInfo: ProductInfo;
	env = environment;
	userInfo: UserInfo;

	constructor(private productService: ProductService, private sessionQuery: SessionQuery) {}

	ngOnInit(): void {
		this.productService.getProductInfo().subscribe(p => (this.productInfo = p));
		this.sessionQuery.userInfo$.subscribe(u => (this.userInfo = u));
	}

	get currentYear(): number {
		return new Date().getFullYear();
	}

	hideMenu(): boolean {
		return !this.userInfo || this.userInfo.hasPendingOnboarding;
	}
}
